import React from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { Color } from '@tiptap/extension-color';
import { TextStyle } from '@tiptap/extension-text-style';

export default function HTMLParser(props: { html: string }) {
  const { html } = props;
  const editor = useEditor({
    content: html,
    extensions: [StarterKit, Color, TextStyle],
  });
  if (!editor) {
    return null;
  }
  editor.setEditable(false);
  return <EditorContent editor={editor} />;
}
